function defer(method) {
    if (window.jQuery && $('.fe-share-design').length) {
        method();
    } else {
        setTimeout(function () { defer(method) }, 50);
    }
}

defer(() => {
    $('#opt_in').click()
    $('#subscribe-email').val(localStorage.getItem('email'));
    $('.optin-success').hide();

    $('.fe-share-design').click(function () {
        $('.optin-success').hide();
        $('.optin-fail').hide();
        $('.optin-wrapper').show();
        $('#share-design h4').show()
        $('#share-design p').show()
        $('#share-design .modal-heading').show()
        buttonText = $('.modal-submit').html()
        $('.modal-submit').removeAttr('disabled');
    })

    var buttonText = ''

    function submitForm(e) {
        e.preventDefault();
        // Add your logic to submit to your backend server here.
        grecaptcha.execute(clientId, {
            action: 'saveDesign'
        }).then(function (token) {
            localStorage.setItem('email', $('#subscribe-email').val());
            $('.modal-submit').html('Loading...')
            $('.modal-submit').attr('disabled', '')

            $.ajax({
                url: 'https://hook.eu1.make.com/jdb4blep5djkhdq2plomorxg1act6uqk',
                type: "POST",
                data: {
                    product_url: $('.share-design__link').val(),
                    user_email: $('#subscribe-email').val(),
                    subscribe: $('#opt_in').is(":checked"),
                    token
                },
                error: function () {
                    $('.optin-success').hide();
                    $('.optin-fail').show();
                    $('#share-design h4').hide()
                    $('#share-design p').hide()
                    $('.optin-wrapper').hide()
                },
                success: function (response) {
                    $('.modal-submit').html(buttonText)
                    $('.modal-submit').removeAttr('disabled')
                    $('.optin-success').show();
                    $('.optin-fail').hide();
                    $('#share-design h4').hide()
                    $('#share-design p').hide()
                    $('.optin-wrapper').hide()
                }
            });
        });
    }


    $('#share-design').submit(submitForm)

})